<template>
  <v-navigation-drawer
    app fixed dark floating touchless
    disable-resize-watcher
    class="secondary"
    :width="isMobile ? '100vw' : 300"
    :value="appMenu"
    @input="value => toggleDrawer({ target: 'appMenu', value })"
  >
    <v-toolbar flat class="secondary" style="border-bottom: 1px solid #424242 !important;">
      <div v-ripple class="home-nav" @click="$router.push('/home')"></div>
      <img class="mr-2 fill-height" :src="ossPath('/images/logos/logo-8.svg')" style="height: 46px;"/>
      <v-toolbar-title class="headline primary--text">
        <span>{{ env.VUE_APP_BRAND_NAME }}</span>
        <span class="white--text mx-1">·</span>
        <span class="accent--text">{{ env.VUE_APP_PLATFORM_NAME }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="isMobile" icon @click="toggleDrawer({ target: 'appMenu', value: false })">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <div :style="height">
      <vue-scroll>
        <v-list two-line>
          <template v-for="item in menus">
            <v-list-group
              v-if="item.items.length > 0"
              v-bind:key="item.path"
              no-action
              :class="{'secondary lighten-1': item.value}"
              :prepend-icon="item.icon"
              :group="item.path"
              :value="item.value"
              @input="expandAppMenu(item.path)"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="title" v-text="item.title"></v-list-item-title>
                  <v-list-item-subtitle v-if="item.desc">{{ item.desc }}</v-list-item-subtitle>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="item in item.items"
                v-bind:key="item.path"
                :to="item.path"
                @click="closeMenu"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                  <v-list-item-subtitle v-if="item.desc">{{ item.desc }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list-group>

            <v-list-item
              v-else
              v-bind:key="item.path"
              active-class="primary--text"
              :to="item.path"
              @click="closeMenu"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="title">{{ item.title }}</v-list-item-title>
                <v-list-item-subtitle v-if="item.desc">{{ item.desc }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
          <template v-if="menus.length === 0">
            <v-skeleton-loader
              v-for="n in 12"
              v-bind:key="n"
              transparent
              type="list-item-avatar-two-line"
            ></v-skeleton-loader>
          </template>
        </v-list>
      </vue-scroll>
      <v-footer height="auto" class="pa-0">
        <v-list class="py-0" style="width: 100%;">
          <v-list-item two-line>
            <v-list-item-avatar class="mr-2" style="width: 50px; max-width: 50px; height: 50px; max-height: 50px;">
              <v-img :src="userAvatar"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>当前用户：{{ userName }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-footer>
    </div>
  </v-navigation-drawer>
</template>

<script>
  import { mapState } from 'vuex'
  import drawer from '../../../../mixins/drawer'

  export default {
    name: 'app-menu',
    mixins: [drawer],
    data: () => ({
      env: process.env
    }),
    computed: {
      ...mapState({
        appMenu: state => state.appMenu,
        pages: state => state.pages,
        menus: state => state.menus
      }),
      height () {
        return {
          height: `calc(100% - ${this.$vuetify.breakpoint.mdAndUp ? '64px' : '56px'} - 66px)`
        }
      },
      userAvatar () {
        return _.get(this.user, 'weixin.avatar') || this.ossPath('/images/logos/logo-8.svg')
      },
      userName () {
        return _.get(this.user, 'name') || _.get(this.user, 'weixin.nickname') || '匿名用户'
      },
      userCompany () {
        return _.get(this.user, 'company.name') || '匿名公司'
      }
    },
    methods: {
      closeMenu () {
        if (this.isMobile) {
          this.toggleDrawer({
            target: 'appMenu',
            value: false
          })
        }
      },
      expandAppMenu (path) {
        this.$store.commit('assignValue', {
          menus: _.map(_.cloneDeep(this.menus), menu => Object.assign(menu, {
            value: menu.path === path ? !menu.value : menu.value
          }))
        })
      }
    }
  }
</script>

<style lang="scss">
  .home-nav {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0;
      background-color: #ffffff;
      -webkit-transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
      transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
    }

    &:hover::before {
      opacity: 0.08;
    }
  }
</style>
